import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: true,
    num: 1,
    isTips: false,
    isLogin: localStorage.getItem('isLogin') || false,
    toastMessage: '', // 提示文本
    toastType: '' // 提示类型 success/error
  },
  getters: {
  },
  mutations: {
    changeLoad(state, payload) {
      state.isLoading = payload
      state.num++
    },
    setToastInfo(state, { msg, type }) {
      state.toastMessage = msg
      state.toastType = type
      state.isTips = true // 赋值后直接显示
    },
    changeTipType(state) {
      state.isTips = false
    },
    setLogin(state,type){
      state.isLogin = type
      localStorage.setItem('isLogin',type)
    }
  },
  actions: {
  },
  modules: {
  }
})
